import PageWrapper from "../../../../components/common/layout/PageWrapper";
import React from "react";
import { useTranslation } from "react-i18next";
import GlobalMessage from "./GlobalMessage";

const GlobalMessageManagement = () => {
  const { t } = useTranslation();

  return (
    <PageWrapper title={t("t.page.global.message.admin")}>
      <GlobalMessage></GlobalMessage>
    </PageWrapper>
  );
};

export default GlobalMessageManagement;
